import React from "react";

// components
import Link from "@/components/Link";

// helpers
import { ILocationSinglePageHeader } from "./ILocationSinglePageHeader";

// assets
import styles from "@/assets/styles/pages/location-single-page/location-single-page-header.module.scss";


function LocationSinglePageHeader(props: ILocationSinglePageHeader) {
  const {
    title,
    locationType,
    isNew,
    collectionsQuery,
    ...rest
  } = props;


  return (
    <div className={styles["locl-location-single-page-header"]} {...rest}>
      <Link
        href={`/search-results?collections__in=${collectionsQuery}`}
        className={styles["locl-location-single-page-header__location-type"]}
      >
        {locationType}
      </Link>
      <div className={styles["locl-location-single-page-header__main-info"]}>
        <div className={styles["locl-location-single-page-header__main-info__left"]}>
          <h1 className={styles["locl-location-single-page-header__title"]}>{title}</h1>
          { isNew && (
            <div className={styles["locl-location-single-page-header__badge-new"]}>New</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LocationSinglePageHeader;
